import React, { LazyExoticComponent } from 'react';
import { Route, Redirect } from 'react-router-dom';

import Compare from 'containers/Compare';
import Capture from 'containers/Capture';
import Configuration from 'containers/Configuration';
import ImageComparison from 'containers/ImageComparison';
import Timestamp from 'containers/Timestamp';
import DataGrid from 'containers/DataGrid';

import { parseUrlParams } from 'lib/common';

interface Props {
    CustomComponent: (() => JSX.Element) | typeof Compare | typeof Capture | typeof Configuration | typeof ImageComparison | LazyExoticComponent<typeof Compare> | LazyExoticComponent<typeof Capture> | LazyExoticComponent<typeof Configuration> | LazyExoticComponent<typeof ImageComparison> | LazyExoticComponent<typeof Timestamp> | LazyExoticComponent<typeof DataGrid>;
    user: any;
    path: string;
    exact: boolean;
}

/**
 * https://maksimivanov.com/posts/firebase-react-tutorial/
 * https://reacttraining.com/react-router/web/api/Route/render-func
 * @export
 * @param {Component} props
 * @param {...any[]} rest
 * @returns
 */
export default function PrivateRoute({
  CustomComponent,
  user,
  ...rest
}: Props) {
  return (
    <Route
      {...rest}
      render={(routeProps) => (user || parseUrlParams(routeProps.location.search).auth === undefined //THIS IS TEMPORARY TODO: REMOVE THIS.
        ? (<CustomComponent {...routeProps} />)
        : (<Redirect to={{ pathname: '/login', state: { from: routeProps.location } }} />))}
    />
  );
}
